import React, { ReactNode, RefObject } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import logo from '../../../img/home/structure.svg';
import entityApi from '../../../network/api/entityApi';
import Button from '../../common/Button';
import { EntityDTO } from '../../../network/api/types/compte/EntityDTO';
import StructureSelected from './components/StructureSelected';
import { getStructureNameV2 } from '../../../services/utils';
import { toastError } from '../../common/Notification';

type Props = {
  divRef: RefObject<HTMLDivElement>;
  update: (values) => void;
  entityId: string;
};

type State = {
  selectedStructure: EntityDTO,
};

class CreationStructurePro extends React.Component<Props, State> {
  state: State = {
    selectedStructure: null,
  };

  componentDidMount(): void {
    this.getEnrolementEntity();
  }

  getEnrolementEntity = (): void => {
    entityApi.fetchEntityById(this.props.entityId)
      .then((response: EntityDTO) => {
        this.setState({ selectedStructure: response });
      })
      .catch(() => toastError(I18n.t('message.ERROR')));
  };

  validate = (): void => {
    this.props.update({
      entities: [this.state.selectedStructure],
    });
  };

  render(): ReactNode {
    const { selectedStructure } = this.state;
    return (
      <div ref={this.props.divRef} className="account-activation-form-container enrolement">
        <div className="account-activation-col">
          <h3>
            <Translate value="CREATION.VALIDATE_STRUCTURE_PRO" />
          </h3>
        </div>
        <div className="account-activation-col add-structure-form">
          <Translate value="CREATION.VALIDATE_RATTACHEMENT" />
          {selectedStructure
            && (
              <div className="selected-structures">
                <StructureSelected
                  key={selectedStructure.ou}
                  structureName={getStructureNameV2(selectedStructure)}
                  structureGeographicAddress={selectedStructure.residence}
                  structurePCcode={selectedStructure.departementResidence?.libelle}
                />
              </div>
            )}
          <div className="button-container enrolement">
            <Button
              type="primary"
              onClick={this.validate}
              disabled={selectedStructure === null}
              i18nKey="actions.VALIDATE"
            />
          </div>
        </div>
        <div className="account-activation-col">
          <div>
            <img className="logo" src={logo} alt="logo" />
          </div>
          <Translate value="CREATION.RATTACHEMENT" />
        </div>
      </div>
    );
  }
}

export default CreationStructurePro;
